import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('recebimento', 'integracao/nota_debito');

const notaDebitoActions = {
  enviaND: { method: 'POST', url: `${basePath}/{idNotaDebito}` },
};

export default (resource) => resource(`${basePath}`, {}, notaDebitoActions);
